import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadGenehmigungKategorieListStatus: 'idle',
    loadGenehmigungKategorieListError: undefined as any,
    loadGenehmigungKategorieListLastArgs: undefined as any,

    genehmigungKategorieList: [] as any[],
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadGenehmigungKategorieList = createAsyncThunk('auftragGenehmigungKategorieSlice/loadGenehmigungKategorieList', async ({ forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().auftragGenehmigungKategorieSlice.loadGenehmigungKategorieListLastArgs
    if (_.isEqual(lastArgs, {  }) && !forceReload) { return }

    let promises = []
    promises.push(client.get(
        `/api/ixweb/nurisgenehmkat/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: {  }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadGenehmigungKategorieListStatus } = getState().auftragGenehmigungKategorieSlice
        return loadGenehmigungKategorieListStatus !== 'pending'
    }
})

const GenehmigungKategorieSlice = createSlice({
    name: 'auftragGenehmigungKategorieSlice',
    initialState,
    reducers: {
        resetloadGenehmigungKategorieListError: (state) => {
            state.loadGenehmigungKategorieListError = undefined
        },
        removeFromGenehmigungKategorieListById: (state, action) => {
            state.genehmigungKategorieList = state.genehmigungKategorieList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromGenehmigungKategorieListByIds: (state, action) => {
            state.genehmigungKategorieList = state.genehmigungKategorieList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.genehmigungKategorieList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadGenehmigungKategorieListStatus = 'preloaded'
            state.loadGenehmigungKategorieListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.genehmigungKategorieList = []
            state.loadGenehmigungKategorieListStatus = 'idle'
            state.loadGenehmigungKategorieListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadGenehmigungKategorieList.pending, (state) => {
            state.loadGenehmigungKategorieListStatus = 'pending'
            state.loadGenehmigungKategorieListError = undefined
        })
        builder.addCase(loadGenehmigungKategorieList.fulfilled, (state, action) => {
            state.loadGenehmigungKategorieListStatus = 'idle'

            if (!action.payload) { return }

            state.loadGenehmigungKategorieListLastArgs = action.payload.args

            {
                state.genehmigungKategorieList = action.payload.data

            }
        })
        builder.addCase(loadGenehmigungKategorieList.rejected, (state, action) => {
            state.loadGenehmigungKategorieListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadGenehmigungKategorieListError = action.error.message
            } else {
                state.loadGenehmigungKategorieListError = action.payload
            }
        })

    }
})

export const {
    resetloadGenehmigungKategorieListError,
    removeFromGenehmigungKategorieListById,
    removeFromGenehmigungKategorieListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = GenehmigungKategorieSlice.actions
export default GenehmigungKategorieSlice.reducer
